import calcSavingsSummary from "./calc_savings_summary";
import calcInvestmentSummary from "./calc_investment_summary";
import addRateOfReturnToSummaryArr from "./add_rate_of_return_to_summary_arr";


export const createOverviewProfile=(savingsInfo, summaryBuyArr, featureLevel, gameNbrMonths) => {
    let summaryArr = [];
    let totalByInvestTypeArr = [];
    if (savingsInfo.gameID){
        const savingsArr = savingsInfo.savingsArr;
        calcSavingsSummary(savingsArr, "bank", summaryArr);
        if (+featureLevel >= 2){
            calcSavingsSummary(savingsArr, "retirement", summaryArr, gameNbrMonths);
        }
    };
     
    for (let i=0; i<summaryBuyArr.length; i++){
        const summaryBuyObj = summaryBuyArr[i];
        const investType = summaryBuyObj.investType;
        const investTypeArr = calcInvestmentSummary(summaryBuyObj, investType, summaryArr);
        totalByInvestTypeArr = totalByInvestTypeArr.concat(investTypeArr);
    }
      
    for (let i=0; i<summaryArr.length; i++){
        summaryArr[i].totalInitialValue = (+summaryArr[i].totalInitialValue).toFixed(2);
        summaryArr[i].totalCurrentValue = (+summaryArr[i].totalCurrentValue).toFixed(2);
        const gainOrLoss = (+summaryArr[i].totalCurrentValue - 
            +summaryArr[i].totalInitialValue).toFixed(2);
        let rateOfReturn = 0;
        if (+summaryArr[i].totalInitialValue === 0){
            if (+gainOrLoss === 0){
                rateOfReturn = 0;
            }else{
                rateOfReturn = 100;
            }
        }else{
            rateOfReturn = ((+gainOrLoss / +summaryArr[i].totalInitialValue) * 100).toFixed(2);
        }
        addRateOfReturnToSummaryArr(summaryArr[i].accountLabel, summaryArr[i].subType, rateOfReturn, 
            summaryArr);
    }
    summaryArr.sort((a,b) => (a.sortNbr > b.sortNbr) ? 1: -1);
    return summaryArr
}
export default createOverviewProfile;